import JotformPage from "@components/Jotform/JotformPage";
import Loading from "@components/layout/Loading";
import getFormId from "@utils/forms";
import { useCurrentUserMutation } from "@utils/hooks";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type AddActivityDetailsProps = {};

const AddActivityDetails: React.FC<AddActivityDetailsProps> = () => {
  const { mutate, isSuccess, isLoading } = useCurrentUserMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isSuccess) {
      navigate("/pension-application");
    }
  }, [isSuccess, isLoading, navigate]);

  return !isLoading ? (
    <JotformPage
      formId={getFormId("business_details")}
      onSubmit={() => {
        mutate({
          pension_applied_activity_information: true,
        });
        // navigate("/pension-application");
      }}
    />
  ) : (
    <Loading />
  );
};
export default AddActivityDetails;